export default {
  CATEGORY_A: 'A',
  CATEGORY_B: 'B',
  CATEGORY_C: 'C',
};



// WEBPACK FOOTER //
// ./src/variables/itineraryPrices/itineraryPricesCategories.js